import { render, staticRenderFns } from "./ReviewPoints.vue?vue&type=template&id=4cb90e7a&"
import script from "./ReviewPoints.vue?vue&type=script&lang=js&"
export * from "./ReviewPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports